import {Component, OnInit} from '@angular/core';
import {NewSessionModalComponent} from '../new-session-modal/new-session-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-patient-dashboard',
    templateUrl: './patient-dashboard.component.html',
    styleUrls: ['./patient-dashboard.component.scss']
})
export class PatientDashboardComponent implements OnInit {
    latestResults = [
        {
            img: true,
            name: 'S d',
            results: [
                {
                    title: 'A6-H-39',
                    color: 'red'
                },
                {
                    title: 'A6-H-39',
                    color: 'yellow'
                },
                {
                    title: 'PCL-5 29',
                    color: 'yellow'
                },
                {
                    title: 'A6-H-39',
                    color: 'green'
                },
                {
                    title: 'A6-H-39',
                    color: 'red'
                }
            ]
        },
        {
            img: false,
            name: 'S d',
            text: 'asd'
        },
        {
            img: true,
            name: 'S d',
            text: 'asd',
            results: [
                {
                    title: 'A6-H-39',
                    color: 'red'
                },
                {
                    title: 'A6-H-39',
                    color: 'yellow'
                },
                {
                    title: 'PCL-5 29',
                    color: 'yellow'
                },
                {
                    title: 'A6-H-39',
                    color: 'green'
                },
                {
                    title: 'A6-H-39',
                    color: 'red'
                }
            ]
        },
        {
            img: false,
            name: 'S d',
            text: 'asd'
        },
        {
            img: true,
            name: 'S d',
            text: 'asd',
            results: [
                {
                    title: 'A6-H-39',
                    color: 'red'
                },
                {
                    title: 'A6-H-39',
                    color: 'yellow'
                },
                {
                    title: 'PCL-5 29',
                    color: 'yellow'
                },
                {
                    title: 'A6-H-39',
                    color: 'green'
                },
                {
                    title: 'A6-H-39',
                    color: 'red'
                }
            ]
        },
        {
            img: false,
            name: 'S d',
            text: 'asd'
        }
    ];
    latestList = [];

    chatCards = [1, 2, 3, 4];

    constructor(
        private modalService: NgbModal,
    ) {
    }

    ngOnInit(): void {
    }
    newSession() {
        const modalRef = this.modalService.open(NewSessionModalComponent, {
            centered: true,
            size: 'lg',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });
        modalRef.componentInstance.data = {};
        return modalRef.result;
    }
    onPager(prop: any) {
        this.latestList = prop;
    }

}
